import ReactTimeAgo from "react-time-ago";

import { Tag } from "@design-system/Tag/Tag";
import { Text } from "@design-system/Text/Text";

type Props = {
  date: Date;
  dayOnly?: boolean;
};

const formatDayLevel = (date: Date): string => {
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();

  if (diffMs < 0) return "In the future";

  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffDays > 0) {
    return `${diffDays} day${diffDays !== 1 ? "s" : ""} ago`;
  }
  return "Today";
};

export const DateCell = ({ date, dayOnly }: Props) => {
  return (
    <Tag
      color="tertiary"
      noWrap
      right={
        <Text color="inherit" size={11}>
          {dayOnly ? formatDayLevel(date) : <ReactTimeAgo date={date} />}
        </Text>
      }
    />
  );
};
